<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

function AddRapiCustomButtonVariant() {
    if (typeof jQuery === 'undefined') {
        console.log('Waiting for jQuery...');
        setTimeout(AddRapiCustomButtonVariant, 50);
        return;
    }

    // Insert CSS once jQuery is ready:
    $('<style>')
        .text(`
.rapi-bundles__bar-variant-selects {
  align-items:center;
}

.rapi-swatch-button {
  width: 30px;
  height: 30px;
  border: 2px solid #ddd;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  margin: 0;
  position: relative;
  overflow: hidden;
  transition: border-color 0.2s ease;
  background: transparent;
}

.rapi-swatch-button.selected {
  border-color: #ff4d7d;
}

.rapi-swatch-container {
  display: flex;
  gap: 10px;
  margin: 5px 0;
}

.rapi-bundles__bar-variant-selects {
  gap:20px!important;
}

.rapi-swatch-button .pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
}

/* Add these new styles */
.rapi-swatch-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.rapi-swatch-label {
  font-size: 12px;
  color: #666;
  text-align: center;
  width: min-content;
  line-height: normal;
}
        `)
        .appendTo('head');

    // ----------------------------------------
    // Below is your variant-building logic
    // ----------------------------------------
    function createVariantButtonsRapi() {
        function handleRadioSelection($container) {
            const $selectedInput = $container.find('input[type="radio"]:checked');
            if ($selectedInput.length) {
                const $label = $selectedInput.closest('.rapi-bundles__bar-container');
                if ($label.length) {
                    const $variantsSection = $label.find('.rapi-bundles__bar-variants');
                    if ($variantsSection.length) {
                        $variantsSection.show();
                    }
                }
            }
        }

        $('.rapi-bundles__bar-variant-wrapper').each(function() {
            if ($(this).attr('data-processed')) return;

            const $variantNames = $(this).closest('.rapi-bundles__bar-variants')
                .find('.rapi-bundles__bar-variant-names');

            const isFirstVariantColor = $variantNames.find('span:first-child')
                .text().trim() === 'Culoare';

            if (!isFirstVariantColor) return;

            $(this).find('.rapi-bundles__bar-variant').each(function() {
                const $colorSelect = $(this).find('.rapi-bundles__bar-variant-select').first();
                if (!$colorSelect.length || $colorSelect.attr('data-processed')) return;

                const $swatchContainer = $('<div>', {
                    class: 'rapi-swatch-container'
                });

                $colorSelect.find('option').each(function() {
                    const option = $(this);

                    // Create wrapper div for swatch and label
                    const $wrapper = $('<div>', {
                        class: 'rapi-swatch-wrapper'
                    });

                    const $swatch = $('<button>', {
                        type: 'button',
                        class: 'rapi-swatch-button',
                        'data-value': option.val()
                    });

                    const $pattern = $('<span>', {
                        class: 'pattern'
                    });

                    // Create label with variant name
                    const $label = $('<span>', {
                        class: 'rapi-swatch-label',
                        text: option.text()
                    });

                    $swatch.append($pattern);
                    $wrapper.append($swatch, $label);
                    $swatchContainer.append($wrapper);

                    // Extract file number from URL
                    function extractFileNumberName(url) {
                        if (!url) return null;
                        const match = url.match(/\/files\/([a-zA-Z0-9-_]+)(?:_[^.]+)?\.(?:png|jpg|jpeg|webp)/i);
                        if (match) {
                            return match[1].replace(/_(?:medium|130x)$/, '');
                        }
                        return null;
                    }

                    // Click handler
                    $wrapper.on('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        // Set the select value using jQuery
                        $colorSelect.val(option.val());
                        // Dispatch a native change event
                        const selectElement = $colorSelect[0];
                        const event = new Event('change', { bubbles: true });
                        selectElement.dispatchEvent(event);

                        // Mark the clicked swatch as selected
                      // $(this)
                      //   .closest('.rapi-swatch-container')
                      //   .find('.rapi-swatch-button')
                      //   .removeClass('selected');
                      $(this)
                        .find('.rapi-swatch-button')
                        .addClass('selected');

                        // Force the parent bundle bar to be "checked"
                        const $bundleBar = $(this).closest('.rapi-bundles__bar');
                        if ($bundleBar.length) {
                            const $radio = $bundleBar.find('input[type="radio"]');
                            if ($radio.length) {
                                $radio.prop('checked', true);
                                handleRadioSelection($bundleBar.closest('.rapi-bundles__bars'));
                            }
                        }

                        // Attempt to trigger a click on matching images
                        const bgUrl = $(this).find('.pattern').css('background-image');
                      console.log('Swatch clicked with background:', bgUrl);
                      
                        const fileNumber = extractFileNumberName(bgUrl);
                      console.log('Looking for images matching:', fileNumber);
                      
                        if (fileNumber) {
                            const matchingImage = $('.productView-images img').filter(function() {
                                const srcset = $(this).attr('data-srcset') || $(this).attr('srcset');
                                if (!srcset) return false;
                                const thisFileNumber = extractFileNumberName(srcset);
                              console.log('Comparing:', thisFileNumber, 'with:', fileNumber);
                                return thisFileNumber === fileNumber;
                            });
                          
                          console.log('Found matching images:', matchingImage.length);
                          
                            if (matchingImage.length) {
                              // Try to find the parent slide if it exists
                                const $slide = matchingImage.closest('.swiper-slide');
                                if ($slide.length) {
                                  console.log('Triggering click on slide:', $slide);
                                    $slide.trigger('click');
                                } else {
                                  console.log('Triggering click on image:', matchingImage);
                                    matchingImage.trigger('click');
                                }
                            }
                        }
                    });

                    // Set initial selected state if <option selected>
                    if (option.prop('selected')) {
                        $swatch.addClass('selected');
                    }
                });

                // Listen for select changes (native event fired above)
                $colorSelect.on('change', function() {
                    const selectedValue = $(this).val();
                    $swatchContainer.find('.rapi-swatch-button').each(function() {
                        $(this).toggleClass('selected', $(this).data('value') === selectedValue);
                    });
                });

                $colorSelect.parent().prepend($swatchContainer);
                $colorSelect.hide().attr('data-processed', 'true');

                // Apply background styles from original swatches
                $('.product-form__swatch .product-form__label[name="Culoare"]').each(function() {
                    const variantId = $(this).attr('data-variant-id');
                    const $inputCuloare = $('input[data-variant-id="' + variantId + '"]');
                    if ($inputCuloare.length) {
                        const value = $inputCuloare.val();
                        const $pattern = $(this).find('.pattern');
                        if ($pattern.length) {
                            $('.rapi-swatch-button[data-value="' + value + '"] .pattern')
                              .attr('style', $pattern.attr('style'));
                        }
                    }
                });
            });

            $(this).attr('data-processed', 'true');
        });

    }

    // Observe .productView-product for changes
    function observeForRapiVariants(containerSelector) {
        const targetNode = document.querySelector(containerSelector);
        if (!targetNode) {
            console.warn(`Container ${containerSelector} not found`);
            return;
        }

        const config = { childList: true, subtree: true };
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    if ($('.rapi-bundles__bar-variant-select').length) {
                        createVariantButtonsRapi();
                    }
                }
            }
        });

        observer.observe(targetNode, config);
    }

    $(document).ready(function() {
        // Start observing .productView-product
        observeForRapiVariants('.productView-product');

        // Also handle clicks on bundle bars to re-initialize if needed
        $(document).on('click', '.rapi-bundles__bar', function() {
            setTimeout(createVariantButtonsRapi, 100);
        });
    });
}





        // Clear old swatch selection on default swatch click
          // 1) outside any functions, at top‐level of your JS:
          let _shouldClearRapi = false;
          
          // 2) mark real user presses on the Shopify swatches
          $(document).on('pointerdown mousedown touchstart', '.product-form__label', function() {
            _shouldClearRapi = true;
          });
          
          // 3) on *every* click on the Shopify swatch labels
          $(document).on('click', '.product-form__label', function() {
            if (_shouldClearRapi) {
              // only clear when the user actually pressed this label
              $('.rapi-swatch-button').removeClass('selected');
            }
            // reset for the next cycle
            _shouldClearRapi = false;
          });


AddRapiCustomButtonVariant();
// -----------------------------------------------------------------------------
// END Rapi bundle - change default to swatch thumbnail
// -----------------------------------------------------------------------------

// Scroll pagination
document.addEventListener("DOMContentLoaded", function () {
  attachAjaxPagination();
});

function attachAjaxPagination() {
  const paginationLinks = document.querySelectorAll('.pagination-wrapper a');
  paginationLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const url = this.getAttribute('href');

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newProductGrid = doc.querySelector('#main-collection-product-grid');
          const newPagination = doc.querySelector('.pagination-wrapper');

          if (newProductGrid && newPagination) {
            document.querySelector('#main-collection-product-grid').innerHTML = newProductGrid.innerHTML;
            document.querySelector('.pagination-wrapper').innerHTML = newPagination.innerHTML;

            // Smooth scroll to top
            document.querySelector('.block_product_header').scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          } else {
            console.error("Unable to find updated product grid or pagination in the fetched HTML.");
          }
          
          // Reattach to new pagination links
          attachAjaxPagination();
        })
        .catch(error => console.error("Error fetching new page:", error));
    });
  });
}
// -----------------------------------------------------------------------------
// ReelUp Swipe feature - Attach to ALL slides, even if newly added
// -----------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes("/products/reel")) {
  // Your code here will run if the pathname contains "/products/reel"
    
    let attempts = 0;
    const maxAttempts = 30;
    const checkInterval = setInterval(() => {
      attempts++;
      
      // We need the next/prev icons AND the main container that holds .reelUp_video_elem
      const nextBtn = document.querySelector('.reelUp_stacked_next .reelUp_stacked_icon');
      const prevBtn = document.querySelector('.reelUp_stacked_prev .reelUp_stacked_icon');
      const reelContainer = document.querySelector('.reelUp_playlist_stacked_view_wrapper');
      
      if (nextBtn && prevBtn && reelContainer) {
        clearInterval(checkInterval);
        console.log('[ReelUp Swipe] Found nextBtn, prevBtn, reelContainer - attaching swipe logic.');
  
        // 1) Attach swipe to all existing videos
        attachSwipeToAllVideos(nextBtn, prevBtn, reelContainer);
  
        // 2) Watch for newly added slides
        observeReelContainerForNewSlides(reelContainer, nextBtn, prevBtn);
  
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        console.warn('[ReelUp Swipe] Elements not found in time. Swipe script not attached.');
      }
    }, 500);

  
    console.log("This is the reel product page!");
  }

});

/**
 * Loop over all .reelUp_video_elem found within reelContainer and attach if not already attached.
 */
function attachSwipeToAllVideos(nextBtn, prevBtn, reelContainer) {
  const videoElems = reelContainer.querySelectorAll('.reelUp_video_elem');
  console.log(`[ReelUp Swipe] Found ${videoElems.length} .reelUp_video_elem in container. Attempting to attach...`);

  videoElems.forEach(video => {
    // Only attach once per video element
    if (!video.dataset.swipeAttached) {
      video.dataset.swipeAttached = 'true';
      addSwipeNavigation(video, nextBtn, prevBtn);
      console.log('[ReelUp Swipe] Attached swipe to:', video);
    }
  });
}

/**
 * Use a MutationObserver to re-run attachSwipeToAllVideos whenever new slides appear.
 */
function observeReelContainerForNewSlides(reelContainer, nextBtn, prevBtn) {
  const observer = new MutationObserver((mutations) => {
    let newVideosFound = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        newVideosFound = true;
      }
    });
    // If we see new child nodes, attempt to attach swipe again
    if (newVideosFound) {
      console.log('[ReelUp Swipe] Detected new slides/video elements - reattaching...');
      attachSwipeToAllVideos(nextBtn, prevBtn, reelContainer);
    }
  });

  observer.observe(reelContainer, { childList: true, subtree: true });
}

/**
 * Attach the actual swipe logic to a single videoElem.
 */
function addSwipeNavigation(videoElem, nextBtn, prevBtn) {
  let startX = 0;
  let isNavigating = false;
  const swipeThreshold = 30;  // # of pixels needed to trigger a swipe
  const cooldownTime = 500;   // ms to prevent spammy swipes

  videoElem.addEventListener('touchstart', (e) => {
    if (isNavigating) return;
    startX = e.touches[0].clientX;
  });

  videoElem.addEventListener('touchend', (e) => {
    if (isNavigating) return;
    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;

    if (Math.abs(diff) > swipeThreshold) {
      isNavigating = true;
      if (diff > 0) {
        console.log('[ReelUp Swipe] Swiping LEFT – trigger next ReelUp clip');
        nextBtn.click();
      } else {
        console.log('[ReelUp Swipe] Swiping RIGHT – trigger previous ReelUp clip');
        prevBtn.click();
      }
      setTimeout(() => {
        isNavigating = false;
      }, cooldownTime);
    }
  });
}
// -----------------------------------------------------------------------------
// END ReelUp Swipe feature
// -----------------------------------------------------------------------------
